<template>
  <BaseDialog v-bind="$attrs" size="mini" v-model="showDialog">
    <v-card elevation="0">
      <v-card-title class="pt-0">
        <slot name="title"> {{ title }}</slot>
      </v-card-title>
      <v-card-text>
        <v-row dense class="justify-center">
          <v-col :cols="10" :key="index" v-for="(item, index) in items">
            <v-btn class="full-width mb-2" large @click="selectAction(item)">
              {{ item.text }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </BaseDialog>
</template>

<script>
import baseDialogMixin from '@/services/baseDialogMixin';

export default {
  mixins: [baseDialogMixin],
  props: {
    title: {
      type: String,
      default: ' Select Action',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    selectAction(item) {
      this.$emit('select', item);
    },
  },
};
</script>

<style lang="scss" scoped></style>
